import { C, S, font, fontCond } from "../constants";
import { Avatar, WinRateBar, PlayerPopover } from "../components/ui";
import { getBlockStatus, getChallengeStatus, getPlayerStats } from "../lib/helpers";

// Calcula saldo de posições relativo à posição inicial.
// Positivo = subiu (ex: era 5, agora é 3 → saldo +2)
// Negativo = desceu (ex: era 3, agora é 5 → saldo -2)
function getPositionSaldo(p) {
  if (p.initialPosition == null) return null;
  return p.initialPosition - p.position;
}

export default function RankingScreen({ sorted, me, state, isPublic, currentUser, rankSearch, setRankSearch, setStatsModal, isMobile }) {
  const filteredPlayers = rankSearch
    ? sorted.filter(p => p.name.toLowerCase().includes(rankSearch.toLowerCase()))
    : sorted;

  const isLoggedIn = !!currentUser;

  return (
    <div style={isMobile ? S.cardMobile : S.card}>
      <div style={S.title}>🏅 Ranking — {sorted.length} atletas</div>
      <input
        style={{ ...S.input, marginBottom: 12 }}
        placeholder="🔍  Buscar jogador..."
        value={rankSearch}
        onChange={e => setRankSearch(e.target.value)}
      />
      {isMobile ? (
        <div>
          {filteredPlayers.map(p => (
            <PlayerCard key={p.id} p={p} me={me} state={state} isLoggedIn={isLoggedIn} onPress={() => !isPublic && setStatsModal(p)}/>
          ))}
        </div>
      ) : (
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>#</th>
              <th style={S.th}>Jogador</th>
              <th style={S.th}>Status</th>
              <th style={S.th}>V / D</th>
              <th style={S.th}>Taxa</th>
            </tr>
          </thead>
          <tbody>
            {filteredPlayers.map(p => {
              const bl = getBlockStatus(p), st = getPlayerStats(p.name, state.results, p.id), hi = me && p.id === me.id;
              const saldo = getPositionSaldo(p);
              return (
                <tr key={p.id} style={{ background: hi ? "#fff0f2" : "transparent", cursor: "pointer" }} onClick={() => !isPublic && setStatsModal(p)}>
                  <td style={{ ...S.td, fontFamily: fontCond, fontWeight: 900, fontSize: 18, color: p.position <= 3 ? C.warning : C.muted, width: 80 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <span style={{ display: "inline-block", width: 32, flexShrink: 0, fontSize: 13, fontWeight: 800, fontFamily: fontCond, textAlign: "left", color: saldo > 0 ? C.success : saldo < 0 ? "#e53e3e" : "transparent" }}>
                        {saldo > 0 ? `▲${saldo}` : saldo < 0 ? `▼${Math.abs(saldo)}` : "–"}
                      </span>
                      {p.position === 1 ? "🥇" : p.position === 2 ? "🥈" : p.position === 3 ? "🥉" : p.position}
                    </div>
                  </td>
                  <td style={S.td}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      {/* Avatar com popover — stopPropagation para não abrir modal de stats */}
                      <div onClick={e => e.stopPropagation()}>
                        <PlayerPopover player={p} isLoggedIn={isLoggedIn}>
                          <Avatar player={p} size={36}/>
                        </PlayerPopover>
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, color: hi ? C.primary : C.text }}>{p.name}{hi ? " (você)" : ""}</div>
                        {st.total > 0 && <div style={{ fontSize: 11, color: C.muted }}>{st.total} partidas</div>}
                      </div>
                    </div>
                  </td>
                  <td style={S.td}>{(() => {
                    const cs = getChallengeStatus(p, state.challenges);
                    if (bl === "inativo") return <span style={S.badge("#666666")}>Inativo</span>;
                    if (cs === "desafiado" || cs === "ambos" || bl === "bloqueado") return <span style={S.badge("#e53e3e")}>Indisponível</span>;
                    return <span style={S.badge(C.accent)}>Disponível</span>;
                  })()}</td>
                  <td style={S.td}>{st.total > 0
                    ? <span><span style={{ color: C.success, fontWeight: 700 }}>{st.wins}V</span><span style={{ color: C.muted }}> / </span><span style={{ color: "#e53e3e", fontWeight: 700 }}>{st.losses}D</span></span>
                    : <span style={{ color: C.muted }}>—</span>}
                  </td>
                  <td style={{ ...S.td, minWidth: 120 }}>{st.total > 0 ? <WinRateBar rate={st.winRate}/> : <span style={{ color: C.muted }}>—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ── PlayerCard (mobile) ────────────────────────────────────────────────────────
function PlayerCard({ p, me, state, onPress, isLoggedIn }) {
  const hi = me && p.id === me.id;
  const bl = getBlockStatus(p);
  const cs = getChallengeStatus(p, state.challenges);
  const st = getPlayerStats(p.name, state.results, p.id);
  const saldo = getPositionSaldo(p);
  return (
    <div onClick={onPress} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: "1px solid " + C.border, cursor: "pointer", background: hi ? "#fff0f2" : "transparent" }}>
      {/* Posição + setas */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 36, flexShrink: 0, gap: 1 }}>
        <div style={{ fontFamily: fontCond, fontWeight: 900, fontSize: 16, color: p.position <= 3 ? C.warning : C.muted, lineHeight: 1 }}>
          {p.position === 1 ? "🥇" : p.position === 2 ? "🥈" : p.position === 3 ? "🥉" : p.position}
        </div>
        <span style={{ fontSize: 10, fontWeight: 800, fontFamily: fontCond, lineHeight: 1, minHeight: 12, color: saldo > 0 ? C.success : saldo < 0 ? "#e53e3e" : "transparent" }}>
          {saldo > 0 ? `▲${saldo}` : saldo < 0 ? `▼${Math.abs(saldo)}` : "–"}
        </span>
      </div>
      {/* Avatar com popover — stopPropagation para não abrir modal de stats */}
      <div onClick={e => e.stopPropagation()}>
        <PlayerPopover player={p} isLoggedIn={isLoggedIn}>
          <Avatar player={p} size={36}/>
        </PlayerPopover>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: hi ? C.primary : C.text }}>{p.name}{hi ? " (você)" : ""}</div>
        <div style={{ fontSize: 11, color: C.muted }}>{st.total > 0 ? `${st.wins}V ${st.losses}D · ${st.winRate}%` : "Sem partidas"}</div>
      </div>
      <div>
        {bl === "inativo" ? <span style={S.badge("#666666")}>Inativo</span>
          : (cs === "desafiado" || cs === "ambos" || bl === "bloqueado") ? <span style={S.badge("#e53e3e")}>Indisp.</span>
          : <span style={S.badge(C.accent)}>Disp.</span>}
      </div>
    </div>
  );
}
